import AnswerPerformanceView from 'models/location/answer_performance_view';

export default class FilterAnswerPerformance {
  constructor(context) {
    this.context = context;
  }

  run({ audienceId, dateRange }) {
    const currentLocation = this.context.stores.currentLocation.get();
    const currentSort = currentLocation instanceof AnswerPerformanceView ? currentLocation.sort : undefined;

    this.context.router.navigateTo(
      AnswerPerformanceView.create({
        audienceId,
        dateRange,
        sort: currentSort,
      })
    );
  }
}
